import React, { useMemo } from "react";
import ProjectSeparator from "@/components/pages/Community/ProjectSeparator";
import ProjectBox from "@/components/pages/Community/ProjectBox";
import { Title } from "@/components/pages/Community";
import {
  Stack,
  Box,
  Typography,
  Collapse,
  Unstable_Grid2 as Grid
} from "@mui/material";
import styles from "./Projects.module.scss";

const Projects = ({ options, selected, onUnselect }) => {
  const projects = useMemo(() => {
    const projs = {};
    if (!options) return projs;
    options.forEach((option) => {
      projs[option.name] = [...option.projects];
    });
    return projs;
  }, [options]);

  return (
    <>
      {Object.keys(projects).map((optionName) => {
        const key = `${optionName}-project-collapse`;
        return (
          <Collapse in={selected === optionName} key={key}>
            <Grid
              container
              alignItems="center"
              sx={{ paddingBottom: 7, paddingX: { xs: 0, md: 3 } }}
              spacing={{ xs: 4, md: 5 }}
            >
              <Grid xs={12} md={6} lg={4}>
                <Typography
                  variant="body1"
                  component="div"
                  className={styles.contributePanelOptionTextSelected}
                >
                  Selected Project Group:
                </Typography>
                <Typography
                  variant="body1"
                  component="div"
                  className={styles.contributePanelOptionTextUnselect}
                  onClick={onUnselect}
                >
                  Select another project group
                </Typography>
              </Grid>
              <Grid xs={12} md={6} lg={8}>
                <Box>
                  <Box
                    className={[
                      styles.contributePanelOption,
                      styles.contributePanelOptionFilled
                    ].join(" ")}
                  >
                    <div>{optionName}</div>
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <ProjectSeparator />
            <Stack sx={{ padding: 1 }} direction="column" useFlexGap>
              <Box sx={{ paddingBottom: 2 }}>
                <Title
                  sx={{
                    color: "inherit",
                    fontSize: { xs: "21px", md: "34px" },
                    textAlign: { xs: "center", md: "left" }
                  }}
                >
                  Select the project you would like to contribute to...
                </Title>
                <Box className={styles.contributePanelOptionSelectProjectText}>
                  Once you select the project you are interested in contributing
                  to, you will see an in depth guide to contributing. The first
                  step is as easy as that! Don&apos;t see the project you are
                  interested in?{" "}
                  <Typography
                    variant="body1"
                    component="span"
                    className={styles.contributePanelOptionTextUnselect}
                    onClick={onUnselect}
                  >
                    Select another project group
                  </Typography>
                </Box>
              </Box>
              <Grid container spacing={3} sx={{ width: "100%" }}>
                {projects[optionName]?.map((project) => {
                  const itemKey = `${key}-option-${optionName}-project-${project.code_name}`;

                  return (
                    <Grid key={itemKey} xs={12} md={4}>
                      <ProjectBox
                        code_name={project.code_name}
                        mascot_image_url={project.mascot_image_url}
                        name={project.name}
                        documentation_link={project.documentation_link}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Stack>
          </Collapse>
        );
      })}
    </>
  );
};

export default Projects;
